import { render, staticRenderFns } from "./ProjectNameDialog.vue?vue&type=template&id=1b98c65c&"
import script from "./ProjectNameDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectNameDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNameDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports